import React, { Component } from "react";
import Header from "./header";
import SidePanel from "./sidePanel";
import Dashboard from "./dashboard";
import Contract from "./Contract";
import Matrix from "./matrix";
import { ethers } from 'ethers';
import getWallet from '../../services/wallet';
import withWrapper from '../../helpers/withWrapper';
import getContract from "../../services/contract";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { Flip, ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AutoRun from "./autorun";
import Lend from "./Lend";
import Borrow from "./Borrow";
import Autorun2 from "./autorun2";
import Autorun3 from "./autorun3";

class DashboardLayout extends Component {
  constructor(props) {
    
    super(props);
    if(props.router.params.id > 0) {
      this.state.userId = props.router.params.id;
    }
    else {
      this.state.userId = 1;
    }
    // this.notify("Global Reward has no longer been accumulated, All new 10% distribution has been moving to BUSO treasury, But you can still claim");
  }
  state = {
    view: 'dashboard',
    isViewMode: false,
    signer: null,
    isSideBarOpen: false,
  };

  handleSetUserId = (id) => {
    this.setState({userId: id});
  }

  connectWallet = async () => {
    const wallet = await getWallet();
    if(!wallet.isReadOnly) {
      this.setState({ signer: wallet.signer });
      console.log("Wallet Connected");
    }
  }

  handleWalletConnected = async (contract) => {
    this.setState({ signer: contract.signer });
  }

  handleConnectWallet = () => {
    this.connectWallet();
  }

  handleDashboardClick = () => {
    this.props.router.navigate('/dashboard/' + this.state.userId);
    toast.dismiss()
    this.sideBarToggle()
  }

  handleLendClick = () => {
    this.props.router.navigate('/lend/' + this.state.userId);
    toast.dismiss()
    this.sideBarToggle()
  }

  handleBorrowClick = () => {
    this.props.router.navigate('/borrow/' + this.state.userId);
    toast.dismiss()
    this.sideBarToggle()
  }

  handleContractClick = () => {
    this.props.router.navigate('/contracts');
    toast.dismiss()
    this.sideBarToggle()
  }

  handleSwapClick = () => {
    toast.dismiss()
    this.sideBarToggle()
    // Open swap app with userId so "Back to Dashboard" returns to this user's dashboard
    const userId = this.state.userId || 1
    window.open('/swap/?userId=' + userId, '_blank')
  }

  sideBarToggle = () => {
    this.setState({isSideBarOpen: !this.state.isSideBarOpen})
  }

  handleNavigateToRegister = (userId) => {
    this.props.router.navigate('/join?refId=' + userId);
  }

  handleToastError = (message) => {
    this.notify(message);
  }

  handleNavigateToLogin = () => {
    this.props.router.navigate('/login');
  }

  handleSetUserId = (id) => {
    this.setState({userId: id});
  }

  handleSlotClick = (level) => {
    this.props.router.navigate('/dashboard/' + this.state.userId + '/' + level);
    this.setState({ level, view: 'matrix' });
  }

  handleAutoRunClick = (userId) => {
    this.props.router.navigate('/autorun/' + userId);
    this.setState({ userId, view: 'autorun' });
  }

  handleAutoRun2Click = (userId) => {
    this.props.router.navigate('/autorun2/' + userId);
    this.setState({ userId, view: 'autorun2' });
  }

  handleAutoRun3Click = (userId) => {
    this.props.router.navigate('/autorun3/' + userId);
    this.setState({ userId, view: 'autorun3' });
  }

  notify = (message) => toast.error(message, 
    {position: toast.POSITION.BOTTOM_LEFT, delay: "4000", style: {zIndex: "2"}, transition: Flip, autoClose: 4000 });
 
  render() {
    return (
      <div id="__next1">
        <ToastContainer position="bottom-right" theme="colored" autoClose={1000} />
        <div className="relative flex bg-main-bg items-center justify-center min-h-screen min-w-full overflow-hidden">
          <Header
            onConnectWallet={this.handleConnectWallet}
            signer={this.state.signer}
            sideBarToggle={this.sideBarToggle}
            onDisconnect={this.handleNavigateToLogin}
          />
          <div className="flex w-full h-full justify-center max-w-desktop-full">
            <SidePanel onDashboardClick={this.handleDashboardClick} 
              id={this.state.userId}
              onLendClick={this.handleLendClick} onBorrowClick={this.handleBorrowClick} sideBarOpened={this.state.isSideBarOpen}
              onContractsClick={this.handleContractClick}
              onSwapClick={this.handleSwapClick}
            />
            <Routes>
              <Route path="dashboard/:id" element={<Dashboard 
                navigateToRegister={this.handleNavigateToRegister}
                onSetUserId={(id) => this.handleSetUserId(id)}
                onSlotClick={this.handleSlotClick}
                onAutoRunClick={this.handleAutoRunClick}
                onAutoRun2Click={this.handleAutoRun2Click}
                onAutoRun3Click={this.handleAutoRun3Click}
                onError={(message) => this.handleToastError(message)}
                isViewMode={this.state.isViewMode}
                userId={this.state.userId}
                onWalletConnected={this.handleWalletConnected}
              />} />
              <Route path="dashboard/:id/:level" element={<Matrix 
                onSetUserId={(id) => this.handleSetUserId(id)}
                router={this.props.router}
                level={this.state.level}
                userId={this.state.userId}
                idsOnLevel={this.state.idsOnLevel}
              />} />
              <Route path="autorun/:id" element={<AutoRun 
                onSetUserId={(id) => this.handleSetUserId(id)}
                router={this.props.router}
                level={this.state.level}
                userId={this.state.userId}
                idsOnLevel={this.state.idsOnLevel}
              />} />

              <Route path="autorun2/:id" element={<Autorun2 
                onSetUserId={(id) => this.handleSetUserId(id)}
                router={this.props.router}
                level={this.state.level}
                userId={this.state.userId}
                idsOnLevel={this.state.idsOnLevel}
              />} />

              <Route path="autorun3/:id" element={<Autorun3 
                onSetUserId={(id) => this.handleSetUserId(id)}
                router={this.props.router}
                level={this.state.level}
                userId={this.state.userId}
                idsOnLevel={this.state.idsOnLevel}
              />} />

              <Route path="lend/:id" element={<Lend 
                onSetUserId={(id) => this.handleSetUserId(id)}
                router={this.props.router}
                userId={this.state.userId}
                idsOnLevel={this.state.idsOnLevel}
              />} />
            <Route path="contracts" element={<Contract />} />
            <Route path="borrow/:id" element={<Borrow 
                onSetUserId={(id) => this.handleSetUserId(id)}
                router={this.props.router}
            />} />
            
            </Routes>
          </div>
        </div>
      </div>
    );
  }
}

export default withWrapper(DashboardLayout);
